export default "__VITE_ASSET__CEP$EmJD__"